const state = () => ({
  name: "Een ogenblik aub",
  body: "",
  date: new Date(),
  introduction: "",
  onzeSchemeList: [],
});

const getters = {};

const actions = {};

const mutations = {
  updatePublicSchemeItem(state, data) {
    state.name = data.name;
    state.body = data.body;
    state.date = data.date;
    state.introduction = data.introduction;
  },

  updateOnzeSchemeList(state, val) {
    state.onzeSchemeList = val.items;
    state.onzeSchemeListTitle = val.name;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
